import React from "react";
import ReactDOM from "react-dom/client";

import RootComponent from "./RootComponent";
import { ThemeProviderWrapper } from "./themes/ThemeProviderWrapper";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProviderWrapper>
      <RootComponent />
    </ThemeProviderWrapper>
  </React.StrictMode>,
);
